// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.designSystem-dnd-styles-dnd-module-dragCursor {
	cursor: -webkit-grab;
	cursor: grab;
}

.designSystem-dnd-styles-dnd-module-dropPlaceholder {
	background-color: var(--Grey50);
	border-radius: 4px;
	color: var(--Grey800);
	padding: 8px;
	width: 100%;
}

.designSystem-dnd-styles-dnd-module-dragPreview {
	-webkit-box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
	z-index: 1;
}

.designSystem-dnd-styles-dnd-module-dragOverBox {
	outline: var(--DropZoneHoverOutline);
}

.designSystem-dnd-styles-dnd-module-isDragging {
	background-color: var(--Blue50) !important;
}

.designSystem-dnd-styles-dnd-module-isSelected {
	background-color: var(--Blue100) !important;
}

.designSystem-dnd-styles-dnd-module-isSelected:hover {
	outline: 1px solid var(--Blue100);
}

.designSystem-dnd-styles-dnd-module-globalDropZone {
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	position: fixed;
	z-index: -1;
}

.designSystem-dnd-styles-dnd-module-globalDropZoneActive {
	z-index: 9000;
}

.designSystem-dnd-styles-dnd-module-dropDivider {
	background-color: var(--PrimaryBlue);
	margin-top: 3px;
	padding: 1px;
}

.designSystem-dnd-styles-dnd-module-activeDropZoneBorder {
	outline: 2px solid var(--PrimaryBlue);
}

.designSystem-dnd-styles-dnd-module-inactiveDropZoneBorder {
	outline: 2px solid var(--Grey400);
}

/* drag loading indicator */
.designSystem-dnd-styles-dnd-module-dragLoadingIndicator {
	background-color: rgba(0, 0, 0, 0.2);
	bottom: 0;
	left: 0;
	position: absolute;
	right: 0;
	top: 0;
	z-index: 1000;
}

.designSystem-dnd-styles-dnd-module-circularProgressIndicator {
	position: absolute;
	top: calc(50% - 20px);
	left: calc(50% - 20px);
	color: var(--PrimaryBlue);
	width: 40px;
	height: 40px;
}

/* https://github.com/react-dnd/react-dnd/issues/325#issuecomment-1146536721 */
/* you can conditionally set this, only when dragging */
.designSystem-dnd-styles-dnd-module-draggingCursorForBody * {
		cursor: -webkit-grabbing !important;
		cursor: grabbing !important
	}
.designSystem-dnd-styles-dnd-module-draggingCursorForBody * { 
		-webkit-user-select: none; 
		   -moz-user-select: none; 
		            -ms-user-select: none; 
		        user-select: none /* without this I get the text cursor in Safari */
	}

/** Dashed border for Dnd Drop Zones https://stackoverflow.com/questions/70912762/how-to-round-dash-cap-in-css */
.designSystem-dnd-styles-dnd-module-dashedOutline {
	--s: 5px;
	/* stylelint-disable-next-line declaration-empty-line-before */
	position: absolute;
}

.designSystem-dnd-styles-dnd-module-dashedOutlineHorizontal {
	background: 
		radial-gradient(circle closest-side, var(--Grey400) 98%, transparent) 0 0/var(--s) 100%,
		-webkit-gradient(linear, left top, right top, color-stop(50%, var(--Grey400)), color-stop(0, transparent)) calc(var(--s)/2) 0/calc(2*var(--s)) 100%;
	background: 
		radial-gradient(circle closest-side, var(--Grey400) 98%, transparent) 0 0/var(--s) 100%,
		linear-gradient(to right, var(--Grey400) 50%, transparent 0) calc(var(--s)/2) 0/calc(2*var(--s)) 100%;
}

.designSystem-dnd-styles-dnd-module-dashedOutlineVertical {
	background: 
		radial-gradient(circle closest-side, var(--Grey400) 98%, transparent) 0 0/100% var(--s),
		-webkit-gradient(linear, left top, left bottom, color-stop(50%, var(--Grey400)), color-stop(0, transparent)) 0 calc(var(--s)/2)/100% calc(2*var(--s));
	background: 
		radial-gradient(circle closest-side, var(--Grey400) 98%, transparent) 0 0/100% var(--s),
		linear-gradient(var(--Grey400) 50%, transparent 0) 0 calc(var(--s)/2)/100% calc(2*var(--s));
}

.designSystem-dnd-styles-dnd-module-dashedOutlineHorizontalActive {
	background: 
		radial-gradient(circle closest-side, var(--PrimaryBlue) 98%, transparent) 0 0/var(--s) 100%,
		-webkit-gradient(linear, left top, right top, color-stop(50%, var(--PrimaryBlue)), color-stop(0, transparent)) calc(var(--s)/2) 0/calc(2*var(--s)) 100%;
	background: 
		radial-gradient(circle closest-side, var(--PrimaryBlue) 98%, transparent) 0 0/var(--s) 100%,
		linear-gradient(to right, var(--PrimaryBlue) 50%, transparent 0) calc(var(--s)/2) 0/calc(2*var(--s)) 100%;
}

.designSystem-dnd-styles-dnd-module-dashedOutlineVerticalActive {
	background: 
		radial-gradient(circle closest-side, var(--PrimaryBlue) 98%, transparent) 0 0/100% var(--s),
		-webkit-gradient(linear, left top, left bottom, color-stop(50%, var(--PrimaryBlue)), color-stop(0, transparent)) 0 calc(var(--s)/2)/100% calc(2*var(--s));
	background: 
		radial-gradient(circle closest-side, var(--PrimaryBlue) 98%, transparent) 0 0/100% var(--s),
		linear-gradient(var(--PrimaryBlue) 50%, transparent 0) 0 calc(var(--s)/2)/100% calc(2*var(--s));
}
`, "",{"version":3,"sources":["webpack://./src/designSystem/dnd/styles/dnd.module.css"],"names":[],"mappings":"AAAA;CACC,oBAAY;CAAZ,YAAY;AACb;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,qBAAqB;CACrB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC,gDAAsC;SAAtC,wCAAsC;CACtC,UAAU;AACX;;AAEA;CACC,oCAAoC;AACrC;;AAEA;CACC,0CAA0C;AAC3C;;AAEA;CACC,2CAA2C;AAC5C;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,MAAQ;CAAR,QAAQ;CAAR,SAAQ;CAAR,OAAQ;CACR,eAAe;CACf,WAAW;AACZ;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,oCAAoC;CACpC,eAAe;CACf,YAAY;AACb;;AAEA;CACC,qCAAqC;AACtC;;AAEA;CACC,iCAAiC;AAClC;;AAEA,2BAA2B;AAC3B;CACC,oCAAoC;CACpC,SAAS;CACT,OAAO;CACP,kBAAkB;CAClB,QAAQ;CACR,MAAM;CACN,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,yBAAyB;CACzB,WAAW;CACX,YAAY;AACb;;AAEA,8EAA8E;AAE7E,uDAAuD;AACvD;EACC,mCAA2B;EAA3B;CAED;AAHA;EAEC,yBAAgB;KAAhB,sBAAgB;cAAhB,qBAAgB;UAAhB,gBAAgB,EAAE,iDAAiD;CACpE;;AAGD,gHAAgH;AAChH;CACC,QAAQ;CACR,8DAA8D;CAC9D,kBAAkB;AACnB;;AAEA;CACC;;qJAEsG;CAFtG;;uGAEsG;AACvG;;AAEA;CACC;;uJAE4F;CAF5F;;6FAE4F;AAC7F;;AAEA;CACC;;yJAE0G;CAF1G;;2GAE0G;AAC3G;;AAEA;CACC;;2JAEgG;CAFhG;;iGAEgG;AACjG","sourcesContent":[".dragCursor {\n\tcursor: grab;\n}\n\n.dropPlaceholder {\n\tbackground-color: var(--Grey50);\n\tborder-radius: 4px;\n\tcolor: var(--Grey800);\n\tpadding: 8px;\n\twidth: 100%;\n}\n\n.dragPreview {\n\tbox-shadow: 0 2px 4px rgb(0 0 0 / 10%);\n\tz-index: 1;\n}\n\n.dragOverBox {\n\toutline: var(--DropZoneHoverOutline);\n}\n\n.isDragging {\n\tbackground-color: var(--Blue50) !important;\n}\n\n.isSelected {\n\tbackground-color: var(--Blue100) !important;\n}\n\n.isSelected:hover {\n\toutline: 1px solid var(--Blue100);\n}\n\n.globalDropZone {\n\tinset: 0;\n\tposition: fixed;\n\tz-index: -1;\n}\n\n.globalDropZoneActive {\n\tz-index: 9000;\n}\n\n.dropDivider {\n\tbackground-color: var(--PrimaryBlue);\n\tmargin-top: 3px;\n\tpadding: 1px;\n}\n\n.activeDropZoneBorder {\n\toutline: 2px solid var(--PrimaryBlue);\n}\n\n.inactiveDropZoneBorder {\n\toutline: 2px solid var(--Grey400);\n}\n\n/* drag loading indicator */\n.dragLoadingIndicator {\n\tbackground-color: rgba(0, 0, 0, 0.2);\n\tbottom: 0;\n\tleft: 0;\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\tz-index: 1000;\n}\n\n.circularProgressIndicator {\n\tposition: absolute;\n\ttop: calc(50% - 20px);\n\tleft: calc(50% - 20px);\n\tcolor: var(--PrimaryBlue);\n\twidth: 40px;\n\theight: 40px;\n}\n\n/* https://github.com/react-dnd/react-dnd/issues/325#issuecomment-1146536721 */\n.draggingCursorForBody {\n\t/* you can conditionally set this, only when dragging */\n\t* {\n\t\tcursor: grabbing !important; \n\t\tuser-select: none /* without this I get the text cursor in Safari */\n\t}\n}\n\n/** Dashed border for Dnd Drop Zones https://stackoverflow.com/questions/70912762/how-to-round-dash-cap-in-css */\n.dashedOutline {\n\t--s: 5px;\n\t/* stylelint-disable-next-line declaration-empty-line-before */\n\tposition: absolute;\n}\n\n.dashedOutlineHorizontal {\n\tbackground: \n\t\tradial-gradient(circle closest-side, var(--Grey400) 98%, transparent) 0 0/var(--s) 100%,\n\t\tlinear-gradient(to right, var(--Grey400) 50%, transparent 0) calc(var(--s)/2) 0/calc(2*var(--s)) 100%;\n}\n\n.dashedOutlineVertical {\n\tbackground: \n\t\tradial-gradient(circle closest-side, var(--Grey400) 98%, transparent) 0 0/100% var(--s),\n\t\tlinear-gradient(var(--Grey400) 50%, transparent 0) 0 calc(var(--s)/2)/100% calc(2*var(--s));\n}\n\n.dashedOutlineHorizontalActive {\n\tbackground: \n\t\tradial-gradient(circle closest-side, var(--PrimaryBlue) 98%, transparent) 0 0/var(--s) 100%,\n\t\tlinear-gradient(to right, var(--PrimaryBlue) 50%, transparent 0) calc(var(--s)/2) 0/calc(2*var(--s)) 100%;\n}\n\n.dashedOutlineVerticalActive {\n\tbackground: \n\t\tradial-gradient(circle closest-side, var(--PrimaryBlue) 98%, transparent) 0 0/100% var(--s),\n\t\tlinear-gradient(var(--PrimaryBlue) 50%, transparent 0) 0 calc(var(--s)/2)/100% calc(2*var(--s));\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dragCursor": `designSystem-dnd-styles-dnd-module-dragCursor`,
	"dropPlaceholder": `designSystem-dnd-styles-dnd-module-dropPlaceholder`,
	"dragPreview": `designSystem-dnd-styles-dnd-module-dragPreview`,
	"dragOverBox": `designSystem-dnd-styles-dnd-module-dragOverBox`,
	"isDragging": `designSystem-dnd-styles-dnd-module-isDragging`,
	"isSelected": `designSystem-dnd-styles-dnd-module-isSelected`,
	"globalDropZone": `designSystem-dnd-styles-dnd-module-globalDropZone`,
	"globalDropZoneActive": `designSystem-dnd-styles-dnd-module-globalDropZoneActive`,
	"dropDivider": `designSystem-dnd-styles-dnd-module-dropDivider`,
	"activeDropZoneBorder": `designSystem-dnd-styles-dnd-module-activeDropZoneBorder`,
	"inactiveDropZoneBorder": `designSystem-dnd-styles-dnd-module-inactiveDropZoneBorder`,
	"dragLoadingIndicator": `designSystem-dnd-styles-dnd-module-dragLoadingIndicator`,
	"circularProgressIndicator": `designSystem-dnd-styles-dnd-module-circularProgressIndicator`,
	"draggingCursorForBody": `designSystem-dnd-styles-dnd-module-draggingCursorForBody`,
	"dashedOutline": `designSystem-dnd-styles-dnd-module-dashedOutline`,
	"dashedOutlineHorizontal": `designSystem-dnd-styles-dnd-module-dashedOutlineHorizontal`,
	"dashedOutlineVertical": `designSystem-dnd-styles-dnd-module-dashedOutlineVertical`,
	"dashedOutlineHorizontalActive": `designSystem-dnd-styles-dnd-module-dashedOutlineHorizontalActive`,
	"dashedOutlineVerticalActive": `designSystem-dnd-styles-dnd-module-dashedOutlineVerticalActive`
};
module.exports = ___CSS_LOADER_EXPORT___;
